module.exports = __webpack_public_path__ + "ec6678cc7f58ab97b1a14708ce4d7dd1.png";